import React, { Dispatch, SetStateAction, useCallback } from "react";
import { useOutletContext } from "react-router-dom";
import Editor from "../../../components/WriteProject/Editor/Editor";
import WpTitle from "../../../components/WriteProject/WpTitle/WpTitle";
import { ProjectType } from "../../../interface/interface";

type OutletType = {
  type: "project" | "meetup";
  Insert: (template: string) => void;
  state: ProjectType;
  Save: (template: string | undefined) => void;
  status: "fix" | "new";
  setIsLook: Dispatch<SetStateAction<boolean>>;
  UpdateCommon: (type: string, payload: string | number) => void;
};

function Step6() {
  const {
    type,
    Insert,
    state: { template },
    Save,
    status,
    setIsLook,
    UpdateCommon,
  }: OutletType = useOutletContext();
  const SaveTemplate = useCallback(
    (e: string) => {
      UpdateCommon("template", e);
    },
    [UpdateCommon]
  );

  return (
    <div className="step6">
      <WpTitle
        title={
          type === "project"
            ? "팀 프로젝트 소개"
            : type === "meetup"
            ? "팀 밋업 소개"
            : "매거진 내용 작성"
        }
      />
      <Editor
        type={type}
        Insert={Insert}
        fixData={template}
        status={status}
        Save={Save}
        setIsLook={setIsLook}
        SaveTemplate={SaveTemplate}
      />
    </div>
  );
}

export default Step6;
